export default __webpack_public_path__ + "static/media/Meal_Juice.51252095.svg";